/**
 * Helper functions for number conversion and comparison
 *
 * @export
 * @class NumberHelper
 */
export class NumberHelper {

    /**
     * Returns the smaller of the given numbers
     *
     * @static
     * @param {number} a
     * @param {number} b
     * @returns {number}
     * @memberof NumberHelper
     */
    public static Min(a: number, b: number): number {
        return b > a ? a : b;
    }

    /**
     * Returns the larger of the given numbers
     *
     * @static
     * @param {number} a
     * @param {number} b
     * @returns {number}
     * @memberof NumberHelper
     */
    public static Max(a: number, b: number): number {
        return b < a ? b : a;
    }
}
